module.exports = __webpack_public_path__ + "img/map.ba241f7b.jpg";